export * from './stopPowers.component';
